<template>
  <div class="aboutUs">
    <img src="../../assets/images/logo.png">
    <p><b>版本:  4.0</b></p>
    <div class="Operations">
      <p>官方运营号:</p>
      <span v-if="list.wx_public_name">
        <img src="../../assets/images/weixin.png">
        <b>微信公众号:</b>
        <!--<i>{{list.wx_public_name}}</i>-->
        <i>{{list.wx_public_name}}<input ref="input0" :value="list.wx_public_name" readonly/></i>
        <!--<i @click="copy(0)">复制</i>-->
      </span>
      <span v-if="list.applets_name">
        <img src="../../assets/images/smallprogram.png">
        <b>小程序:</b>
        <!--<i>{{list.applets_name}}</i>-->
        <i>{{list.applets_name}}<input ref="input1" :value="list.applets_name" readonly/></i>
        <!--<i @click="copy(1)">复制</i>-->
      </span>
    </div>
    <div class="CompanyProfile" v-if="list.company_profile">
      <p>公司简介</p>
      <span>{{list.company_profile}}</span>
    </div>
    <footer>
      <p><b @click="agreement">用户协议</b>｜<b @click="privacyPolicy">隐私政策</b></p>
      <span>西安创客村</span>
    </footer>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'aboutUs',
  data () {
    return {
      list: {}
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'aboutus'})
    }
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getAboutUs_URL
      var that = this
      that.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          that.list = res.data.data
        }
      })
    },
    agreement: function () {
      this.$router.push({
        path: 'agreement',
        query: {
          pt: 'app'
        }
      })
    },
    privacyPolicy: function () {
      window.location.href = '/static/wx/html/privacyPolicyApp.html'
    }
  }
}
</script>

<style scoped lang="scss">
  .aboutUs {
    padding-top: 0.41rem;
    padding-bottom: 0.51rem;
    position: relative;
    background: #fff;
    /*min-height: 100%;*/
    >img {
      width: 0.73rem;
      height: 0.73rem;
      margin: 0 auto 0.32rem;
    }
    >p {
      font-size:0;
      margin-bottom: 0.72rem;
      b {
        display: block;
        &:first-of-type {
          font-size:0.15rem;
          font-weight:400;
          color:rgba(69,69,69,1);
          line-height:0.21rem;
          text-align: center;
          margin-bottom: 0.03rem;
        }
        /*&:last-of-type {*/
          /*font-size:0.13rem;*/
          /*font-weight:400;*/
          /*color:#4A90E2;*/
          /*line-height:0.18rem;*/
          /*text-align: center;*/
        /*}*/
      }
    }
    .Operations {
      margin: 0 0.3rem 0.14rem;
      padding-bottom: 0.14rem;
      border-bottom: 1px solid #D8D8D8;
      >p {
        font-size:0.15rem;
        font-weight:400;
        color:rgba(68,68,68,1);
        line-height:0.21rem;
        margin-bottom: 0.1rem;
      }
      span:last-of-type {
        margin-top: 0.05rem;
      }
      span {
        display: block;
        overflow: hidden;
        img {
          width: 0.22rem;
          height: 0.22rem;
          float: left;
          margin-right: 0.08rem;
        }
        b {
          display: block;
          font-size:0.13rem;
          font-weight:400;
          color:rgba(186,185,185,1);
          line-height:0.18rem;
          letter-spacing:1px;
          float: left;
          margin-right: 0.05rem;
        }
        i:first-of-type {
          font-style: normal;
          display: block;
          font-size:0.13rem;
          font-weight:400;
          color:rgba(68,68,68,1);
          line-height:0.18rem;
          letter-spacing:1px;
          float: left;
          margin-right: 0.06rem;
          input {
            border: none;
            visibility: hidden;
            position: absolute;
          }
        }
        /*i:last-of-type {*/
          /*position: relative;*/
          /*z-index: 10;*/
          /*font-style: normal;*/
          /*display: block;*/
          /*font-size:0.12rem;*/
          /*font-weight:400;*/
          /*color:rgba(74,144,226,1);*/
          /*line-height:0.18rem;*/
          /*float: left;*/
        /*}*/
      }
    }
    .CompanyProfile {
      margin: 0 0.3rem;
      /*padding-bottom: 0.41rem;*/
      p {
        font-size:0.15rem;
        font-weight:400;
        color:rgba(68,68,68,1);
        line-height:0.21rem;
        margin-bottom: 0.06rem;
      }
      span {
        display: block;
        font-size:0.13rem;
        font-weight:400;
        color:rgba(68,68,68,1);
        line-height:0.18rem;
        letter-spacing:0.01rem;
      }
    }
    footer {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding-bottom: 0.06rem;
      p{
        text-align: center;
        font-size:0.12rem;
        font-weight:400;
        color:rgba(74,144,226,1);
        line-height:0.17rem;
        b {
          font-weight: normal;
        }
      }
      span {
        display: block;
        text-align: center;
        font-size:0.11rem;
        font-weight:400;
        color:rgba(191,191,191,1);
        line-height:0.16rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/aboutUs.vue